import { createSlice } from '@reduxjs/toolkit'

export const themeModes = {
  light: 'light',
  dark: 'dark'
}

const initialState = {
  themeMode: themeModes.light,
  openProjectModal: false,
  projectToDisplay: null,
  currentLinks: []
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleThemeMode: state => {
      state.themeMode = (state.themeMode === themeModes.light) ?
        themeModes.dark : themeModes.light
    },
    setThemeMode: (state, action) => {
      state.themeMode = action.payload
    },
    setOpenProjectModal: (state, action) => {
      state.openProjectModal = action.payload
    },
    setProjectToDisplay: (state, action) => {
      state.projectToDisplay = action.payload
    },
    setCurrentLinks: (state, action) => {
      state.currentLinks = action.payload
    }
  }
})

export const {
  toggleThemeMode,
  setThemeMode,
  setOpenProjectModal,
  setProjectToDisplay,
  setCurrentLinks
 } = themeSlice.actions

export const toggleThemeModePersist = () => (dispatch, getState) => {
  dispatch(toggleThemeMode())
}

export default themeSlice.reducer
